import { SVGProps } from 'react';

export const Report = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 9.66648H4.27252C4.20515 9.37132 4.16665 9.06516 4.16665 8.74983C4.16665 6.4715 6.01323 4.62491 8.29156 4.62491C8.44648 4.62491 8.5991 4.635 8.74989 4.65196V0.958324C8.74989 0.705329 8.54456 0.5 8.29156 0.5H3.25V9.66648Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.3333 0.5H0.958324C0.705329 0.5 0.5 0.705329 0.5 0.958324V9.20815C0.5 9.46115 0.705329 9.66648 0.958324 9.66648H2.3333V0.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.66654 8.10224L8.93964 7.37488L9.66654 6.64798L10.3934 7.37488L9.66654 8.10224ZM7.59857 10.1693L6.62922 10.4117L6.87213 9.44283L8.29156 8.02295L9.018 8.74985L7.59857 10.1693ZM9.99058 5.67586C9.81137 5.49665 9.52171 5.49711 9.34251 5.67586L6.13424 8.88412C6.07604 8.94325 6.03387 9.01658 6.0137 9.09724L5.55538 10.9305C5.51642 11.0868 5.56225 11.2523 5.67638 11.3659C5.78958 11.4792 5.95504 11.5254 6.11133 11.4865L7.94462 11.0282C8.02529 11.008 8.09862 10.9658 8.15774 10.9076L11.366 7.69936C11.5448 7.51969 11.5448 7.23095 11.366 7.05129L9.99058 5.67586Z"
      fill="currentColor"
    />
  </svg>
);
